import { ApolloError } from "@apollo/client";
import { ErrorLink } from "@apollo/client/link/error";
import { getApiErrorHandlingOptionsFromApolloContext } from "../apiRequestOptions";
import { formatUnknownError } from "../notifications/formatError";
import { getGlobalNotifier } from "../notifications/notifier";

export const makeErrorLink = (
  _callbacks?: Partial<{ graphQl: () => void; network: () => void }>,
) => {
  return new ErrorLink(({ graphQLErrors, networkError, operation }) => {
    const apolloError = new ApolloError({ graphQLErrors, networkError });
    const apiErrorHandling = getApiErrorHandlingOptionsFromApolloContext(
      operation.getContext(),
    );
    // Connection-loss noise is handled by the WS connection notifier in initApolloClient2.
    // Avoid spamming the user with near-duplicate messages like:
    // - "Socket closed"
    // - "WebSocket connection failed"
    const msg = apolloError.message ?? "";
    if (
      msg.includes("Socket closed") ||
      msg.includes("WebSocket connection failed") ||
      msg.includes("Connection closed")
    ) {
      return;
    }

    console.error(apolloError);

    // Avoid spamming on auth transitions (login redirects will handle this).
    if (apolloError.message.includes("Unauthorized")) {
      return;
    }

    if (apiErrorHandling?.showErrorToast === false) {
      return;
    }

    const formatted = formatUnknownError(apolloError, {
      defaultMessage:
        apiErrorHandling?.defaultMessage ??
        "Die Anfrage konnte nicht abgeschlossen werden.",
      keyPrefix: apiErrorHandling?.keyPrefix ?? "api",
      operationContext: apiErrorHandling?.operationContext,
    });
    getGlobalNotifier().notify(formatted.level, formatted.message, {
      key: formatted.key ?? `api:${formatted.message}`,
      description: formatted.description,
    });
  });
};
